import assets from 'modules/assets'

export function links(data) {
  // Feeds into RowThreeBlock
  return {
    content: [
      {
        linkURL: 'https://www.instagram.com/gakko_camp/',
        style: 'grid-small spotlight-link',
        title: 'Find us on Instagram',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/camp3.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'http://facebook.com/gakkoproject',
        style: 'grid-small grid-middle spotlight-link',
        title: 'Follow us on Facebook',
        subTitle: 'Sign up for our newsletter',
        firstRow: {
          type: 'img',
          imageURL: assets('images/get-involved/newsletter.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'mailto:hello@gakkoproject.com?Subject=Hello',
        style: 'grid-small spotlight-link',
        title: 'Get in touch',
        subTitle: 'Apply now',
        firstRow: {
          type: 'img',
          imageURL: assets('images/get-involved/contact.jpg'),
          style: ''
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/getInvolved.js